import { ref } from "vue";

export const isQrcodeReaderOpen = ref<boolean>(false)
export const isNotificationsModalOpen = ref<boolean>(false)
